<div class="headerFlexW pr-4 m-3">
  <div class="content-block">
    <p class="bread-crumbs">STP/OrdenPago</p>
    <h2 class="">Listado de Ordenes de Pago</h2>
  </div>
  <dx-button text="Registrar ORden Pago" icon="plus" type="default" routerLink="add"></dx-button>
</div>

<div class="content-block">
  <div class="dx-card responsive-paddings pt-2"> 

    <!-- Results -->
    <div class="mt-5">
      <dx-data-grid keyExpr="id" 
        [dataSource]="ordenesPago" 
        [masterDetail]="{ enabled: true, template: 'detail' }"
        [allowColumnReordering]="true" 
        [showBorders]="true" 
        [columnAutoWidth]="true">
        <dxo-export 
          [enabled]="true"
          [allowExportSelectedData]="true"
          fileName="STP Abonos"
        ></dxo-export>
        <dxo-load-panel [enabled]="true"></dxo-load-panel>
        <dxo-paging [pageSize]="10"></dxo-paging>
        <dxo-pager [showPageSizeSelector]="true" [allowedPageSizes]="[5, 10, 25, 50, 100]" [showInfo]="true">
        </dxo-pager>
        <!-- <dxi-column dataField="dateCreated" caption="Creada" cellTemplate="dateTemplate" alignment="center">
        </dxi-column> -->
        <dxi-column dataField="id" caption="No."  dataType="number" alignment="center"></dxi-column>
        <dxi-column dataField="companyLegalName" caption="Empresa" alignment="center"></dxi-column>
        <dxi-column dataField="referenciaNumerica" caption="Referencia" alignment="center"></dxi-column>
        <dxi-column dataField="dateCreated" caption="Fecha" dataType="date" format="dd/MM/yyyy hh:mm a" alignment="center"></dxi-column>
        <dxi-column dataField="estadoOrdenPago" caption="Estado" alignment="center"></dxi-column>
        <dxi-column dataField="status" caption="Estatus" alignment="center"></dxi-column>
        <dxi-column dataField="monto" caption="Monto" dataType="number" format="currency">
          <dxo-format type="currency" [precision]="2"></dxo-format>
        </dxi-column>

        <!-- Details -->
        <div *dxTemplate="let orden of 'detail'">
          <div class="flex flex-nowrap details-templateW  datagrid-detailsW flex-space-around">
            <div class="mr-5">
              <h2>Detalle</h2>
              <ul class="list-no-style">
                <li><strong> IdSTP: {{ orden.data.idSTP }}</strong> </li>
                <li><strong> Monto: {{ orden.data.monto | currency }}</strong> </li>
                <li><strong> Refereneica Númerica: {{ orden.data.referenciaNumerica }}</strong> </li>
                <li><strong> Clave Rastreo: {{ orden.data.claveRastreo }}</strong> </li>
                <li><strong> Concepto: {{ orden.data.conceptoPago }}</strong> </li>
                <li><strong> Empresa: {{ orden.data.empresa }}</strong> </li>
                <li><strong> Tipo Pago: {{ orden.data.tipoPago }}</strong> </li>
                <li><strong> Fecha Operación: {{ orden.data.fechaOperacion }}</strong> </li>
                <li><strong> Fecha Registro: {{ orden.data.fechaRegistro }}</strong> </li>
                <li><strong> Estatus: {{ orden.data.status }}</strong></li>
              </ul>
            </div>
            <div class="mr-5">
              <h2>Institución</h2>
              <ul class="list-no-style">
                <li><strong> Institución Contraparte: {{ orden.data.institucionContraparte }}</strong> </li>
                <li><strong> Institución Operante: {{ orden.data.institucionOperante }}</strong> </li>
                <li><strong> Topología: {{ orden.data.topologia }}</strong> </li>
                <li><strong> Folio Origen: {{ orden.data.folioOrigen }}</strong> </li>
                <li><strong> Causa Devolución: {{ orden.data.causaDevoucion }}</strong></li>
                <li><strong> Estado: {{ orden.data.estadoOrdenPago }}</strong> </li>
              </ul>
            </div>
            <div class="mr-5">
              <h2>Beneficiario</h2>
              <ul class="list-no-style">
                <li><strong> Nombre: {{ orden.data.nombreBeneficiario }}</strong> </li>
                <li><strong> Cuenta: {{ orden.data.cuentaBeneficiario }}</strong> </li>
                <li><strong> RFC/CURP: {{ orden.data.rfcCurpBeneficiario }}</strong> </li>
                <li><strong> Tipo Cuenta: {{ orden.data.tipoCuentaBeneficiario }}</strong> </li>
              </ul>
            </div>
            <div class="mr-5">
              <h2>Ordenante</h2>
              <ul class="list-no-style">
                <li><strong> Nombre: {{ orden.data.nombreOrdenante }}</strong> </li>
                <li><strong> Cuenta: {{ orden.data.cuentaOrdenante }}</strong> </li>
                <li><strong> RFC/CURP: {{ orden.data.rfcCurpOrdenante }}</strong> </li>
                <li><strong> Tipo Cuenta: {{ orden.data.tipoCuentaOrdenante }}</strong> </li>
              </ul>
            </div>
          </div>
        </div>

      </dx-data-grid>
    </div>
  </div>
</div>
